export const KEYS = {
    backspace: 'Backspace',
    left: 'ArrowLeft',
    up: 'ArrowUP',
    right: 'ArrowRight',
    down: 'ArrowDown',
};

export const DEFAULT_FIELDS_LENGTH = 4;
